import { all } from 'redux-saga/effects';
import orderWatcher from './ordersaga';

export default function* rootSaga(action) {
	yield all([orderWatcher(action)]);
}
